"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchUsersAccounts = exports.searchAccounts = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * @param  {string} q Search String
 * @param  {number} s Sequence number
 */
async function searchAccounts(q, s) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: '/search-api/search/accounts',
        params: {
            q, s
        }
    });
    return resp.data;
}
exports.searchAccounts = searchAccounts;
/**
 * @description Search for accounts accessible by the user
 * @param  {string} q Search String
 * @param  {number} s Sequence number
 * @param  {boolean} h Current Account Holder only
 * @param  {string} f Account filter preset
 */
async function searchUsersAccounts(q, s, h, f) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: '/search-api/search',
        params: {
            q, s, h, f
        }
    });
    return resp.data;
}
exports.searchUsersAccounts = searchUsersAccounts;
